export const TRANSITION = {
  EASING: 'ease-in-out',
  MOVE_MS: 260,
  STEP_DELAY_MS: 70,
  FADE_IN_MS: 220,
  FADE_OUT_MS: 220
};

function capture(container) {
  const map = new Map();
  if (!container) return map;
  container.querySelectorAll('[data-key]')?.forEach((el) => {
    const rect = el.getBoundingClientRect();
    map.set(el.getAttribute('data-key'), rect);
  });
  return map;
}

export function preparePositions(container) {
  return capture(container);
}

export function fadeOutCard(container, key, { duration = TRANSITION.FADE_OUT_MS } = {}) {
  if (!container) return Promise.resolve();
  const el = container.querySelector(`[data-key="${CSS.escape(key)}"]`);
  if (!el) return Promise.resolve();
  return new Promise((resolve) => {
    el.style.transition = `opacity ${duration}ms ${TRANSITION.EASING}, transform ${duration}ms ${TRANSITION.EASING}`;
    el.style.opacity = '0';
    el.style.transform = 'scale(0.92)';
    setTimeout(() => {
      el.style.transition = '';
      resolve();
    }, duration + 30);
  });
}

export function fadeInCard(container, key, { duration = TRANSITION.FADE_IN_MS } = {}) {
  if (!container) return;
  const el = container.querySelector(`[data-key="${CSS.escape(key)}"]`);
  if (!el) return;
  el.style.opacity = '0';
  el.style.transform = 'scale(0.96)';
  // force reflow
  void el.offsetWidth; // eslint-disable-line no-unused-expressions
  el.style.transition = `opacity ${duration}ms ${TRANSITION.EASING}, transform ${duration}ms ${TRANSITION.EASING}`;
  el.style.opacity = '1';
  el.style.transform = 'scale(1)';
  setTimeout(() => {
    el.style.transition = '';
  }, duration + 30);
}

export function reArrangeCards(container, beforePositions, {
  duration = TRANSITION.MOVE_MS,
  stepDelay = TRANSITION.STEP_DELAY_MS
} = {}) {
  if (!container) return;
  const after = capture(container);
  const movers = [];
  after.forEach((rectAfter, key) => {
    const rectBefore = beforePositions.get(key);
    if (!rectBefore) return; // new element, handled separately
    const dx = rectBefore.left - rectAfter.left;
    const dy = rectBefore.top - rectAfter.top;
    if (dx !== 0 || dy !== 0) movers.push({ key, dx, dy });
  });

  // Order movers by visual reading order (top-left to bottom-right)
  const orderedEls = movers
    .map((m) => {
      const el = container.querySelector(`[data-key="${CSS.escape(m.key)}"]`);
      const rect = el?.getBoundingClientRect?.();
      return { ...m, el, top: rect?.top || 0, left: rect?.left || 0 };
    })
    .sort((a, b) => (a.top - b.top) || (a.left - b.left));

  orderedEls.forEach((m, idx) => {
    const el = m.el;
    if (!el) return;
    el.style.willChange = 'transform';
    el.style.transition = 'none';
    el.style.transform = `translate(${m.dx}px, ${m.dy}px)`;
  });

  // reflow
  void container.offsetWidth; // eslint-disable-line no-unused-expressions

  orderedEls.forEach((m, idx) => {
    const el = m.el;
    if (!el) return;
    el.style.transition = `transform ${duration}ms ${TRANSITION.EASING}`;
    el.style.transitionDelay = `${idx * stepDelay}ms`;
    el.style.transform = 'translate(0px, 0px)';
    const total = duration + idx * stepDelay + 40;
    setTimeout(() => {
      el.style.transition = '';
      el.style.transitionDelay = '';
      el.style.willChange = '';
    }, total);
  });
}


